/**
 * /frontend/src/features/analytics/components/charts/StackedBarChart.js
 */

import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { CHART_COLORS } from '../../constants/chartColors';

const resolveColor = (key, index) => CHART_COLORS.zone[key] || CHART_COLORS.series[index % CHART_COLORS.series.length];

/**
 * Stacked bar chart.
 * @param {{data:any[],xKey:string,stackKeys:string[],height?:number,yFormatter?:(v:any)=>string}} props
 * @returns {JSX.Element}
 */
const StackedBarChart = ({ data, xKey, stackKeys, height, yFormatter }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <BarChart data={safeData} margin={CHART_CONFIG.margin}>
        <CartesianGrid stroke={CHART_CONFIG.gridStroke} strokeDasharray="4 6" />
        <XAxis dataKey={xKey} stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <YAxis stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} tickFormatter={yFormatter} />
        <Tooltip formatter={yFormatter} />
        <Legend />
        {(stackKeys || []).map((key, index) => (
          <Bar key={key} dataKey={key} stackId="stack" fill={resolveColor(key, index)} radius={[8, 8, 0, 0]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StackedBarChart;
